<dialog-draggable-header>{{this.partId ? 'Modify' : 'Add'}} Part</dialog-draggable-header>

<mat-dialog-content>
  <form [formGroup]="partForm" class="add-parts-form">
    <div>
      <mat-form-field>
        <mat-label>Part Number:</mat-label>
        <input matInput type="text" class="arrows" formControlName="partNumber" #partNumber />
        <mat-error *ngIf="partForm.controls.partNumber.hasError('required')">Required</mat-error>
        <mat-error *ngIf="partNumber.value?.length > 8">Cannot exceed 8 characters.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Part Name:</mat-label>
        <input matInput type="text" formControlName="partName" #partName />
        <mat-error *ngIf="partForm.controls.partName.hasError('required')">Required</mat-error>
        <mat-error *ngIf="partName.value?.length > 200">Cannot exceed 200 characters.</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Program:</mat-label>
        <mat-select formControlName="program">
          <mat-option *ngFor="let program of programs" [value]="program.id">{{program.programNameYear}}</mat-option>
        </mat-select>
        <mat-error *ngIf="partForm.controls.program.hasError('required')">Required</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Part Type:</mat-label>
        <mat-select formControlName="partTypeId">
          <mat-option *ngFor="let partType of partTypes" [value]="partType.partTypeId" (click)="getInnerText(partType)">
            {{partType.partType}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="partForm.controls.partTypeId.hasError('required')">Required</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>R, L, S:</mat-label>
        <mat-select formControlName="rL">
          <mat-option value="R">R</mat-option>
          <mat-option value="L">L</mat-option>
          <mat-option value="S">S</mat-option>
        </mat-select>
        <mat-error *ngIf="partForm.controls.rL.hasError('required')">Required</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Detail/Assembly:</mat-label>
        <mat-select formControlName="dA">
          <mat-option value="D">Detail</mat-option>
          <mat-option value="A">Assembly</mat-option>
        </mat-select>
        <mat-error *ngIf="partForm.controls.dA.hasError('required')">Required</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>LH CSPC:</mat-label>
        <input matInput type="text" formControlName="lhStablePartCode" #lhStablePartCode />
        <mat-error *ngIf="lhStablePartCode.value?.length > 12">Cannot exceed 12 characters.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>RH CSPC</mat-label>
        <input matInput type="text" formControlName="rhStablePartCode" #rhStablePartCode />
        <mat-error *ngIf="rhStablePartCode.value?.length > 12">Cannot exceed 12 characters.</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Opposite Part:</mat-label>
        <input matInput type="text" class="arrows" formControlName="oppositePart" #oppositePart />
        <mat-error *ngIf="oppositePart.value?.length > 8">Cannot exceed 8 characters.</mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
  <button mat-raised-button color="primary" (keypress.enter)="save()" (click)="save()"
    [disabled]="!hasEnabledFields">Save</button>
  <button mat-raised-button (keypress.enter)="close()" (click)="close()">Cancel</button>
</mat-dialog-actions>